import React from 'react';
import {
  Box, Divider,
} from '@material-ui/core';
import * as Yup from 'yup';

import {
  Step, WorkflowWithStepsAndEdges,
} from 'src/types';

import FormikInput from 'src/components/formik/FormikInput';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import useGetRequest from 'src/hooks/useGetRequest';
import SearchableList from 'src/components/SearchableList';
import { createStepWithAction } from 'src/utils/api';
import MiniCard from 'src/components/MiniCard';

import { Alert } from '@material-ui/lab';
import ActionBuilder from '../ActionBuilder';
import FormikCheckbox from '../../../../components/formik/FormikCheckbox';
import FormikSelect from '../../../../components/formik/FormikSelect';
import { ACTION_TYPES, EVENT_ATTRIBUTES_BY_EVENT_TYPE } from '../../../../constants/constants';


interface Props {
  workflow: WorkflowWithStepsAndEdges,
  workflowId: string,
  selectedElementId?: string,
  refreshWorkflow: () => void,
  selectedElement: any,
  selectedElementIncomers: any[],
  selectedElementOutgoers: any[],
}

const ManageAction = ({
  workflow,
  workflowId,
  selectedElement,
  selectedElementIncomers,
  selectedElementOutgoers,
  refreshWorkflow,
}: Props) => {
  const [search, setSearch] = React.useState('');
  const [stepId, setStepId] = React.useState<string>();

  // const { result: actionTypes } = useGetRequest({
  //   url: '/automatic/action-types/',
  //   initialResult: [],
  // });
  const { result: roles } = useGetRequest({
    url: `/automatic/workflows/${workflowId}/roles/`,
    initialResult: [],
  });

  const fieldsConfig = [
    {
      name: 'actionId',
    },
    {
      component: (_: any, formik: any) => (
        <SearchableList
          label="Action"
          options={ACTION_TYPES.sort().map((actionType) => EVENT_ATTRIBUTES_BY_EVENT_TYPE[actionType])}
          searchKey="stepTitle"
          search={search}
          setSearch={setSearch}
          onOptionSelected={(attributes: any) => {
            createStepWithAction(workflowId, {
              id: selectedElement.id,
              fromStepIds: selectedElementIncomers.map((node) => node.id),
              toStepIds: selectedElementOutgoers.map((node) => node.id),
              workflowId,
              actionType: attributes.eventType,
            }).then((_step: Step) => {
              setStepId(_step.id);
              refreshWorkflow();
              formik.setFieldValue('actionId', _step.actionId);
              formik.setFieldValue('action', _step.action);
              formik.setFieldValue('name', _step.name);
            });
          }}
          renderOption={(option: any, onOptionSelected: () => void) => (
            <MiniCard
              icon={option.icon}
              label={option.stepTitle}
              description={option.stepDescription}
              onClick={() => onOptionSelected()}
            />
          )}
        />
      ),
      shouldRender: (formik: any) => !formik.values.actionId,
    },
    {
      name: 'name',
      component: () => (
        <FormikInput
          fullWidth
          label="Step name"
          name="name"
          required
        />
      ),
      validator: Yup.string().required('This field is required.'),
      shouldRender: (formik: any) => Boolean(formik.values.actionId),
    },
  ];

  const actionFields = [
    {
      name: 'requiresApproval',
      component: () => (
        <FormikCheckbox
          label="Requires approval"
          name="requiresApproval"
        />
      ),
    },
    {
      name: 'approverRoleId',
      component: () => (
        <FormikSelect
          fullWidth
          label="Approver role"
          name="approverRoleId"
          options={roles.map((role: any) => ({
            value: role.id,
            label: role.name
          }))}
        />
      ),
      validator: Yup.string().required('This field is required.'),
      shouldRender: (formik: any) => Boolean(formik.values.requiresApproval)
    },
  ];

  const step = stepId && workflow.steps.find((_step) => _step.id === stepId);

  const approvableActionTypes = (
    ACTION_TYPES.filter((actionType) => EVENT_ATTRIBUTES_BY_EVENT_TYPE[actionType].isApprovable)
  );
  // @ts-ignore
  const isApprovable = Boolean(step && approvableActionTypes.includes(step.action?.actionType));

  return (
    <>
      {
        selectedElement ? (
          <>
            {
              step && step.validationErrors.length ? (
                <Box mt={2}>
                  <Alert severity="warning">
                    {
                      step.validationErrors.map((validationError) => <div key={validationError}>{validationError}<br /></div>)
                    }
                  </Alert>
                </Box>
              ) : null
            }
            <Box mt={2}>
              <CRUDConfigForm
                url={`/automatic/workflows/${workflowId}/steps/`}
                objectId={selectedElement.id}
                onFetchSuccess={(_step: Step) => {
                  setStepId(_step.id);
                }}
                onFetchError={() => {
                  setStepId(undefined);
                }}
                fieldsConfig={fieldsConfig}
                onSuccess={() => refreshWorkflow()}
                autoSave
              />
            </Box>
            <Box mt={2}>
              {
                // @ts-ignore
                Boolean(step) && <ActionBuilder step={step} onSuccess={() => refreshWorkflow()} />
              }
            </Box>
            {
              step && isApprovable && (
                <>
                  <Box mb={1} mt={2}>
                    <Divider />
                  </Box>
                  <CRUDConfigForm
                    url={`/automatic/workflows/${workflowId}/actions/`}
                    objectId={step.actionId}
                    fieldsConfig={actionFields}
                    onSuccess={() => refreshWorkflow()}
                    autoSave
                  />
                </>
              )
            }
          </>
        ) : null
      }
    </>
  );
};

export default ManageAction;
